import {Injectable} from '@angular/core';
import {GraphicComponentView} from '../../classes/graphic-component-view/graphic-component-view';
import {ILocalStorageViewsService} from './ILocalStorageViewService';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageViewsService implements ILocalStorageViewsService {
  public keyForLocalStorage = 'savedViews_'; // constant
  public viewsInLocaleStorage: GraphicComponentView[] = [];
  public maximumArraySize: number = 20;

  constructor() {
  }

  getGraphicalComponentViews(projectId: number) {
    const viewsAsString = localStorage.getItem(this.keyForLocalStorage + projectId);
    if (viewsAsString != null) {
      this.viewsInLocaleStorage = JSON.parse(viewsAsString).views;
    }
    return this.viewsInLocaleStorage;
  }

  getGraphicalComponentView(projectId: number, currentIndex: number) {
    this.viewsInLocaleStorage = this.getGraphicalComponentViews(projectId) || this.viewsInLocaleStorage;
    return this.viewsInLocaleStorage[currentIndex];
  }

  setGraphicalComponentViews(graphicComponentView: GraphicComponentView, currentIndex: number, projectId: number) {
    this.viewsInLocaleStorage = this.getGraphicalComponentViews(projectId);
    if (currentIndex < this.maximumArraySize) {
      this.viewsInLocaleStorage.length = currentIndex + 1;
      this.viewsInLocaleStorage.push(graphicComponentView);
      const viewsWithCurrentIndex = {currentIndex: currentIndex + 1, views: this.viewsInLocaleStorage};
      localStorage.setItem(this.keyForLocalStorage + projectId, JSON.stringify(viewsWithCurrentIndex));
      return currentIndex + 1;
    } else {
      for (let i = 0; i < this.maximumArraySize; i++) {
        this.viewsInLocaleStorage.splice(i, 1, this.viewsInLocaleStorage[i + 1]);
      }
      this.viewsInLocaleStorage.splice(this.maximumArraySize, 1, graphicComponentView);
      const viewsWithCurrentIndex = {currentIndex: currentIndex, views: this.viewsInLocaleStorage};
      localStorage.setItem(this.keyForLocalStorage + projectId, JSON.stringify(viewsWithCurrentIndex));
      return currentIndex;
    }
  }

  getCurrentIndex(projectId: number) {
    let currentIndex = -1;
    const viewsAsString = localStorage.getItem(this.keyForLocalStorage + projectId);
    if (viewsAsString != null) {
      currentIndex = JSON.parse(viewsAsString).currentIndex;
    }
    return currentIndex;
  }

  changeIndex(front: boolean = true, projectId, currentIndex) {
    this.viewsInLocaleStorage = this.getGraphicalComponentViews(projectId);
    if (this.viewsInLocaleStorage != null) {
      if (front) {
        if (currentIndex !== this.viewsInLocaleStorage.length - 1) {
          currentIndex = currentIndex + 1;
        }
      } else {
        if (currentIndex !== 0) {
          currentIndex = currentIndex - 1;
        }
      }
      const objectToSend = {currentIndex: currentIndex, views: this.viewsInLocaleStorage};
      localStorage.setItem(this.keyForLocalStorage + projectId, JSON.stringify(objectToSend));
      return currentIndex;
    }
  }

  deleteViews(projectId) {
    localStorage.removeItem(this.keyForLocalStorage + projectId);
  }
}
